module.exports = __webpack_public_path__ + "src/img/create.b7780574.svg";